import "./lib/sentry";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { initI18n } from "./lib/i18n";
import { useAuthStore } from "./stores/authStore";

async function bootstrap() {
  await initI18n();
  useAuthStore.getState().initialize();

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

bootstrap();
